import { inject, injectable } from "inversify";
import { IF360Validator } from "./F360Validator";
import { DIMixins, IUserProfile } from "@/core/@types/types";
import "reflect-metadata";
import type { IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";

@injectable()
export default class CieloValidator implements IF360Validator {
  @inject(DIMixins.USER_PROFILE_STORAGE)
  userProfileMixin!: IUserProfileStorageMixin;

  private isCielo(profile: IUserProfile) {
    return profile?.CodigoCliente?.indexOf("CLO") !== -1;
  }

  handleValidation(): boolean {
    const profile = this.userProfileMixin.handleGetUserProfile();

    if (!profile || !profile.CodigoCliente) return false;

    return this.isCielo(profile);
  }
}
